/**
 * Settings this property on a route will change the default behaviour of the back button.
 * Instead of going one page 'up', the back button will navigate to URL specified in this property.
 */
export const BACK_URL = 'backUrl';
